import { ColDef } from 'ag-grid-community';
import { dateFormatter, dateTimeFormatter } from 'src/app/shared/functions';


export const ExpenseTableColumnDef: ColDef[] = [
  {// ID
    headerName: 'ID',
    field: 'id',
    resizable: true,
    width: 175,
    filter: 'agTextColumnFilter',
    hide: true,
  },
  {// Date
    headerName: 'Date',
    field: 'payment_date',
    resizable: true,
    width: 175,
    filter: 'agTextColumnFilter',
    valueFormatter: dateFormatter,
  },
  {// Type
    headerName: 'Type',
    field: 'type',
    resizable: true,
    width: 175,
    filter: 'agTextColumnFilter',
  },
  {// Reference No.
    headerName: 'Reference No.',
    field: 'reference_number',
    resizable: true,
    width: 175,
    filter: 'agTextColumnFilter',
  },
  {// Payee
    headerName: 'Payee',
    field: 'payee',
    resizable: true,
    tooltipField: 'payee',
    filter: 'agTextColumnFilter',
    flex: 1,
  },
  {// Category 
    headerName: 'Category',
    field: 'category',
    resizable: true,
    width: 200,
    filter: 'agTextColumnFilter',
  },
  {// Total
    headerName: 'Total',
    field: 'total',
    resizable: true,
    width: 125,
    filter: 'agTextColumnFilter',
    valueFormatter: function(params) {
      return '$' + params.value;
    }
  }
];